import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { groupEnd } from 'console';
import { MaterialService } from "../../../services/material.service";
import * as _ from "lodash"

@Component({
  selector: 'app-add-material-modal',
  templateUrl: './add-material-modal.component.html',
  styleUrls: ['./add-material-modal.component.scss']
})
export class AddMaterialModalComponent implements OnInit {
  loading: Boolean = false;
  data: any;
  show = true;
  isMaterial: Boolean = false;
  disabled: Boolean = false;
  isValid: boolean;
  disableUnit: boolean = false
  errMsg: string;
  disabledAssignment: boolean = false;
  courseUnits: any = []
  modelTitle

  ngOnInit() {
    console.log("ON INIT", this.dialogData);
    if (this.dialogData.material != undefined) {
      console.log("data", this.data)
      this.data = JSON.parse(JSON.stringify(this.dialogData.material))
      console.log("what is the final value of display data", this.data);

      // this.data.unitTitle = (this.data.courseUnit && this.data.courseUnit.title) ? this.data.courseUnit.title : ''
      console.log("**In if", this.data);
      // this.data.title = this.dialogData.material.title
      // console.log("this.data.title=====>>>>>", this.data.title);
      // alert(this.data.title)
      // this.data.unitNo = this.dialogData.material.unitNo
      // this.data.type = this.dialogData.material.type
      this.isMaterial = true;
      this.disabled = true
      this.dialogRef.disableClose = false
      // this.getCourseUnits(this.data.course)
    } else if (this.dialogData.data) {
      console.log("call this or not")
      // this.data.unitNo = this.dialogData.data
      this.disableUnit = true
      this.disabled = true
      this.data = this.dialogData.data
    }
    else {
      console.log("final else part");

      this.data = this.dialogData; this.disabled = false
    }

    console.log("** Data is final as render", this.data);
    console.log("type of material type=========", typeof this.data.type);

    if (this.data && this.data.unitList) {
      this.courseUnits = this.data.unitList
      delete this.data['unitList']
    } else {
      this.getCourseUnits(this.data.course)
    }


    // if (this.data && this.data.courseType == 'Level2') {
    //   console.log("call this or not");

    //   this.disabledAssignment = true;
    // } else {
    //   this.disabledAssignment = false;
    // }

    // modal title 
    if (this.data && this.isMaterial == true) {    
      this.modelTitle = 'Edit Material'     
    } else {
      this.modelTitle = 'Add Material'
    }

  }
  constructor(public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public dialogData: any, public _materialService: MaterialService) {
    // NO DEFINITION
  }

  doSubmit() {
    console.log("this.data.title", this.data);

    if (this.data.type == "" || this.data.type == undefined || this.data.title == "" || this.data.title == undefined) {
      this.isValid = false;
      console.log("this.data.type == ''", this.isValid);
    }
    else if (this.data.type == "Reading") {
      this.isValid = (this.data.title != "" || this.data.title != undefined) ? true : false
      console.log("this.data.type == 'READING'", this.isValid);
    }
    else if (this.data.type == "Assignment") {
      this.isValid = this.data.title != "" ? true : false
      console.log("this.data.title !='ASSSIGNMENT'", this.isValid);
      this.isValid = this.data.assignmentNo >= '0' ? true : false
      console.log("this.data.unitNo >= 0 && this.data.assignmentNo >= 0", this.isValid);
    }
    console.log("this.isValid", this.isValid);

    if (this.isValid == true) {
      if (this.isMaterial == true) {
        this.loading = true

        console.log(" Here need to check the  this.data ", this.data)
        let materialData = {
          _id: this.data._id,
          course: this.data.course,
          title: this.data.title,
          // unitNo: this.data.unitNo,
          // assignmentNo: this.data.assignmentNo,
          type: this.data.type,
          // unitTitle: this.data.unitTitle,
          courseFolder: this.data.courseFolder
        }
        if (this.data.unitNo == null) {
          console.log("call this cond or not");
          delete this.data.unitNo
        } else {
          materialData['unitNo'] = this.data.unitNo
        }
        if (this.data.assignmentNo == null) {
          console.log("call this cond or not");
          delete this.data.assignmentNo
        } else {
          materialData['assignmentNo'] = this.data.assignmentNo
        }
        console.log("material data for edit", materialData);
        this._materialService.editMaterial(materialData).subscribe(data => {
          this.data = data;
          this.loading = false;
          console.log(" ************** After Value Step 1 ************** ")
          this.dialogRef.close(data);
        }, err => {
          this.loading = false;
          console.log("error editing material", err)
          this.errMsg = err.msg;
          // if (err.msg == 'This Material Already Exists') {
          //   this.errMsg = "Material with same Unit and Assignmnet number already exists."
          // }

          // this.dialogRef.close();
        })
      }
      else {
        console.log("Submit ", this.data.unitNo);
        // Do Submit
        if (this.data.unitNo == null) {
          console.log("call this cond or not");
          delete this.data.unitNo
        }
        console.log("after delete unit number key", this.data);


        this.loading = true;
        this._materialService.addMaterial(this.data).subscribe(data => {
          console.log(" this.data ", data)
          this.loading = false;
          this.dialogRef.close(data);

        }, err => {
          console.log("erroe adding material", err)
          this.loading = false;
          this.errMsg = err.msg;
        });
      }
    }
    else {

    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getCourseUnits(course) {
    // console.group(" **** Course Id **** ")
    // console.log(" check the course Id ", course)
    this._materialService
      .getCourseUnits(course)
      .subscribe(data => {
        // console.table(data)
        this.courseUnits = data
        // this.choseUnitNumber(this.data.unitNo)
        console.groupEnd()
      }, error => {
        console.error(" Error in getting course units ")
      })
  }


  choseUnitNumber(unitNo) {
    console.group("When unit change  Prefill Unit title ")

    console.log(" unitNo ", unitNo)
    console.log(" Course Units ", this.courseUnits)
    let index = _.findIndex(this.courseUnits, function (o) { return o.unitNo == unitNo; });
    if (index > -1) {
      console.log(" index ", index)
      console.log(" Course Unit Details ", this.courseUnits[index])
      this.data.unitTitle = this.courseUnits[index].title
      this.data.courseFolder = this.courseUnits[index];
    }
    else {
      this.data.unitTitle = null
    }

    console.groupEnd()

  }


}